import React, { useState } from "react";
import { PiGraduationCap } from "react-icons/pi";
import { BiBriefcase } from "react-icons/bi";
// import ScrollTrigger from "react-scroll-trigger";

const Education = () => {
  // const [animationOn, setAnimationOn] = useState(false);

  return (
    <div className="education" id="education">
      <h1 className="mainHeading">Education & Experience</h1>
      <div className="mainEduContent">
            <div className="education2 animate__animated animate__fadeInLeft">
              <h3 className="mainHeadingEdu">Education</h3>
              <div className="eduCon">
                <div className="educationData">
                  <div className="educationLeft">
                    <PiGraduationCap className="eduIcon" /> <br />
                    <span className="eduLine"></span>
                  </div>
                  <div className="educationRight">
                    <p className="eduData">2016 - 2018</p>
                    <h4 className="eduTitle">INTERMEDIATE</h4>
                    <p className="eduPara">
                      I competed my Intermedetiate in Computer Science from 
                      FG degree college cantt with 74%.
                    </p>
                  </div>
                </div>
                <div className="educationData">
                  <div className="educationLeft">
                    <PiGraduationCap className="eduIcon" /> <br />
                    <span className="eduLine"></span>
                  </div>
                  <div className="educationRight">
                    <p className="eduData">2017 - 2018</p>
                    <h4 className="eduTitle">ACIT</h4>
                    <p className="eduPara">
                      I Complete the one year course of ACIT from the
                      Computer Man Institute. 
                    </p>
                  </div>
                </div>
                <div className="educationData">
                  <div className="educationLeft">
                    <PiGraduationCap className="eduIcon" /> <br />
                    <span className="eduLine"></span>
                  </div>
                  <div className="educationRight">
                    <p className="eduData">2019 - 2021</p>
                    <h4 className="eduTitle">WEB DEVELOPMENT</h4>
                    <p className="eduPara">
                      I Completed the 2 years Web Development course in 
                      Gexton Institute. 
                    </p>
                  </div>
                </div>
                <div className="educationData">
                  <div className="educationLeft">
                    <PiGraduationCap className="eduIcon" /> <br />
                    <span className="eduLine"></span>
                  </div>
                  <div className="educationRight">
                    <p className="eduData">2018 - 2022</p>
                    <h4 className="eduTitle">BSIT</h4>
                    <p className="eduPara">
                      I Completed my Bachelors of BSIT in MIT with
                      the 3.63 CGPA and now i go for Masters.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="experience animate__animated animate__fadeInRight">
              <h3 className="mainHeadingEdu">Experience</h3>
              <div className="eduCon">
                <div className="educationData">
                  <div className="educationLeft">
                    <BiBriefcase className="eduIcon" /> <br />
                    <span className="eduLine"></span>
                  </div>
                  <div className="educationRight">
                    <p className="eduData">2018 - 2023</p>
                    <h4 className="eduTitle">FREELANCING</h4>
                    <p className="eduPara">
                      I'm a Freelancer and doing Freelancing for last 5 years 
                      and Working so well. 
                    </p>
                  </div>
                </div>
                <div className="educationData">
                  <div className="educationLeft">
                    <BiBriefcase className="eduIcon" /> <br />
                    <span className="eduLine"></span>
                  </div>
                  <div className="educationRight">
                    <p className="eduData">2019 - 2020</p>
                    <h4 className="eduTitle">TEACHER</h4>
                    <p className="eduPara">
                      I was also a teacher in Dot institute teaching Frontend 
                      Website Development.
                    </p>
                  </div>
                </div>   
                <div className="educationData">
                  <div className="educationLeft">
                    <BiBriefcase className="eduIcon" /> <br />
                    <span className="eduLine"></span>
                  </div>
                  <div className="educationRight">
                    <p className="eduData">2021 - 2022</p>
                    <h4 className="eduTitle">FRONTEND DEVELOPER</h4>
                    <p className="eduPara">
                      I was also work as a front-end developer at Websolve, 
                      a software company
                    </p>
                  </div>
                </div>
                <div className="educationData">
                  <div className="educationLeft">
                    <BiBriefcase className="eduIcon" /> <br />
                    <span className="eduLine"></span>
                  </div>
                  <div className="educationRight">
                    <p className="eduData">2022 - 2023</p>
                    <h4 className="eduTitle">FULL STACK DEVELOPER</h4>
                    <p className="eduPara">
                      Currently i'm working in a US Tech software company for 
                      last 1 year as a Full stack developer.
                    </p>
                  </div>
                </div>
              </div>
            </div>
      </div>
    </div>
  );
};

export default Education;
